import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, App } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser'


/**
 * Generated class for the NotifipopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-notifipopup',
	templateUrl: 'notifipopup.html',
})
export class NotifipopupPage {

	loginId: string;
	api_key: string;
	version: string;

	notice: any;
	html: any
	items: any;
	language: string;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public viewCtrl: ViewController,
		public app: App,
		private sanitizer: DomSanitizer
	) {

		this.notice = navParams.get('list');
	}

	ionViewWillEnter() {
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		
		this.html = this.sanitizer.bypassSecurityTrustHtml(this.notice.body) ;
	}

	_close(idx) {
		this.viewCtrl.dismiss(idx);
	}
}



// WEBPACK FOOTER //
// ./src/pages/notifipopup/notifipopup.ts